module.exports = __webpack_public_path__ + "static/media/1.Grounded.34717c18.mp3";